import { ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { NgEntityServiceLoader } from '@datorama/akita-ng-entity-service';
import { Subscription } from 'rxjs';
import { CsProjectFormComponent } from 'src/app/cs-projects/project-form/cs-project-form.component';
import { CsProject } from 'src/app/cs-projects/state/cs-project.model';
import { csProjectStoreName } from 'src/app/cs-projects/state/cs-project.store';
import { CsProjectsService } from 'src/app/cs-projects/state/cs-projects.service';
import { CsBuildupStateQuery, CsBuildupStateStore, EditableSectionPartComponent } from '../shared';

@Component({
  selector: 'app-project-section',
  templateUrl: './project-section.component.html',
  styleUrls: ['./project-section.component.scss']
})
export class ProjectSectionComponent extends EditableSectionPartComponent implements OnInit, OnDestroy {
  @Input() csProject: CsProject;
  @ViewChild(CsProjectFormComponent) projectForm: CsProjectFormComponent;

  private internalError: string;
  private internalIsBusy: boolean;
  private loaderSubscription: Subscription;

  public get error(): string {
      return this.internalError;
  }

  public get isBusy(): boolean {
    return this.internalIsBusy;
  }

  constructor(
    private service: CsProjectsService,
    private loader: NgEntityServiceLoader,
    protected element: ElementRef<Element>,
    protected csBuildupStore: CsBuildupStateStore,
    protected csBuildupStateQuery: CsBuildupStateQuery) {
    super(element, csBuildupStore, csBuildupStateQuery);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.loaderSubscription = this.loader.loadersFor(csProjectStoreName).update$.subscribe(
      isLoading => this.internalIsBusy = isLoading);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.loaderSubscription.unsubscribe();
  }

  saveChanges(): void {
    const changedProject = this.projectForm.getProject();
    this.internalError = undefined;
    this.service.update<CsProject>(this.csProject.id, changedProject)
      .subscribe(
        updatedProject => {
          this.csProject = updatedProject;
          this.endEdit(); },
        error => { this.internalError = error.message; });
  }

  discardChanges(): void {
    this.projectForm.discardChanges();
    this.endEdit();
  }
}
